import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM } from '../../../components/models';
import { TranslateService } from '@ngx-translate/core';
import { Meses, obtenerError, obtenerTamMax, Responsables } from '../../../models/Formulacion/indicadores-metas/datos';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import { ObjetivosService } from '../../../services/seguimiento/objetivos/objetivos.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { messages } from '../../funciones/mensajes';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../../services/gestion/perspectivas/perspectiva.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { IndicadorService } from '../../../services/gestion/indicadores/indicador.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { AdicionalService } from '../../../services/gestion/adicional/adicional.service';
import { MetaService } from '../../../services/gestion/meta/meta.service';
import { PERMISOS } from '../../../shared/catalogos';

@Component({
  selector: 'app-objetivos',
  templateUrl: './objetivos.component.html',
  styleUrl: './objetivos.component.css'
})
export class ObjetivosComponent implements OnInit {
  public readonly permisos = PERMISOS;
  public Filters = FiltersM;

  public acum = true;

  // Filtros
  public todasPer = true;
  public aniosDisponibles: any = [];
  public perspectives: any = [];
  public selAll = true;
  public viewTablero = false;


  // Variables planeación
  private idPlanificacion: number = 0;
  private semaforo: any[] = [];

  public indicadores: any = [];
  public objectivos: any = [];
  public indicadoresMostrar: any = [];

  private edicion: boolean;
  public Periodo = '';
  public responsables: Responsables[] = [];
  public responsables2: any = [] // MatTableDataSource<Responsables> = [];
  public porcentajeAvance = 0;

  // **** Variables para el formateo de numeros
  public separador: string = ","; // separador para los miles
  public sepDecimal: string = '.'; // separador para los decimales

  public verCodigo = false;
  selectedFiles: FileList;
  //Es el array que contiene los items para mostrar el progreso de subida de cada archivo
  progressInfo = [];
  imageName = "";
  /** click izquierdo */
  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;

  menuTopLeftPosition = { x: '0', y: '0' };
  private adDelete: any;

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private excelService: ExcelService,
    private cookies: CookieService,

    private planificacionService: PlanificacionService,
    private responsableService: ResponsableService,
    private objetivoService: ObjetivoService,
    private indicadorService: IndicadorService,
    private metaService: MetaService,
    private adicionalService: AdicionalService,
  ) {
    this.consultas();
  }

  ngOnInit(): void { }

  private async consultas() {
    this.idPlanificacion = Number(this.cookies.get('idInstitucion'));

    try {
      const planeacionResponse = await this.planificacionService.getPlanificacionByIdGQL(this.idPlanificacion);
      this.obtenerFiltros(planeacionResponse);
      this.perspectives = this.ordenamientoId(this.perspectives);

      const objectives = [];
      for(const per of this.perspectives){
        const obj = await this.objetivoService.getObjectivesByPerspectiveGQL(per.id);
        objectives.push(...obj)
      }
      this.obtenerObjetivos(objectives);

      const indicators = [];
      for(const obj of this.objectivos){
        const ind = await this.indicadorService.getIndicadoresByObjetiveGQL(Number(obj.id));
        indicators.push(...ind)
      }
      this.obtenerIndicadores(indicators.flat());
    } catch (error) {
    }
  }

  private seleccionarPeriodo(){
    this.aniosDisponibles.forEach(a => {
      a.series.forEach(m => m.check = false);
    });
    const ultimoAnio = this.aniosDisponibles[this.aniosDisponibles.length - 1];
    const ultimoPeriodo = ultimoAnio.series[ultimoAnio.series.length - 1];

    const periodoActual = moment().format('MMM-YY').toLowerCase();

    if (ultimoPeriodo.periodo === periodoActual) {
      const series = ultimoAnio.series;
      const indice = series.length - 1;

      if (indice > 0) {
        series[indice - 1].check = true;
        this.Periodo = series[indice - 1].periodo;
      }
    } else {
      ultimoPeriodo.check = true;
      this.Periodo = ultimoPeriodo.periodo;
    }
  }
  private async obtenerFiltros(plan: any) {
    if (plan.institution.acronym === 'IDemo' || plan.institution.acronym === 'Bienestar') {
      //this.verCodigo = true;
    }
    this.edicion = plan.isActive;
    this.aniosDisponibles = Meses.obtenerPeriodos(moment(plan.initial_date).toDate(), moment(plan.end_date).toDate());
    this.seleccionarPeriodo();


    // Agregar visible: true a todos los años y meses
    for (const anio of this.aniosDisponibles) {
      anio.visible = true;
      for (const mes of anio.series) {
        mes.visible = true;
      }
    }
    for (const per of plan.perspectives) {
        this.perspectives.push({
          name: per.name,
          id: per.id,
          check: true,
        });
      }
    const sema = this.ordenamientoSem([].concat(plan.signals));
    for (const sem of sema) {
      this.semaforo.push({
        valIn: Number(sem.value_00),
        valfin: Number(sem.value_01),
        color: sem.color[0],
      });
    }

    try {
      const response = await firstValueFrom(this.responsableService.getResponsable());
      this.responsables = [];
      for (const res of response) {
        if (res.institution.id === plan.institution.id) {
          if (this.dataService.filtradoIndicadores) {
            if (res.responsibles[0].email === this.dataService.user) {
              this.responsables.push({
                id: res.id,
                nombre: res.name,
                name: res.name,
                check: true,
              });
            }
          } else {
            this.responsables.push({
              id: res.id,
              nombre: res.name,
              name: res.name,
              check: true,
            });
          }
        }
      }
      this.responsables = this.ordenamientoId(this.responsables);
      this.responsables2 = new MatTableDataSource(this.responsables);
    } catch (error) {
    }
    this.perspectives = this.ordenamientoId(this.perspectives);
  }

  private obtenerObjetivos(array: any) {
    var aux = [];
    for (const obj of array) {
      for (const per of this.perspectives) {
        if (obj.perspective.id === per.id) {
          aux.push({
            nombre: obj.name,
            id: obj.id,
            idPer: obj.perspective.id,
            peso: obj.weighing,
          });
          per.pondObj += obj.weighing;
          break;
        }
      }
    }
    this.objectivos = [];
    this.objectivos = aux;
    this.objectivos = this.ordenamientoId(this.objectivos);
  }
  private obtenerIndicadores(array: any) {
    var aux = [];
    for (const ind of array) {
      for (const obj of this.objectivos) {
        if (ind.objective.id === obj.id) {
          var metas = [];
          for (const met of ind.goals) {
            const date = moment(met.period).toDate();
            metas.push({
              id: met.id,
              period: date,
              value: met.value,
              real: met.real,
            });
          }
          var adic = [];
          for( const ad of ind.additions){
            var fil = [];
            if (ad.files && ad.files.length !== 0) {
              for (const f of ad.files) {
                const date = moment(f.createdAt).toDate();
                fil.push({
                  id: f.id,
                  name: f.name,
                  description: f.description,
                  path: f.path,
                  created_at: date,
                  updated_at: f.updated_at,
                });
              }
            }
            adic.push({
              indicatorId: ind.id,
              amount: ad.amount,
              comments: ad.comments,
              id: ad.id,
              name: ad.name,
              note: ad.note,
              type: ad.type,
              files: fil,
            });
          }
          adic = this.ordenamientoAd(adic);
          aux.push({
            nombre: ind.name,
            additions: adic,
            tendencia: ind.tendency,
            id: ind.id,
            ponderacion: ind.weighing,
            metas: this.ordenamientoMetas(metas),
            objectiveId: ind.objective,
            fechaIni: ind.initialDate,
            fechaFin: ind.endDate,
            areaId: ind.area.id,
          });
          break;
        }
      }
    }
    this.indicadores = [];
    this.indicadores = aux;
    this.indicadores = this.ordenamientoId(this.indicadores);
    this.indicadores = this.ordenamientoObjId(this.indicadores);
    this.indicadores = this.ordenarPorPerspectiva(this.indicadores);

    this.indicadoresMostrar = [];
    for (const ind of this.indicadores) {
      if (this.Mostrar(ind)) {
        this.indicadoresMostrar.push(ind);
      }
    }
    if (this.indicadoresMostrar.length === 0) {
      Swal.fire({
        title: this.translate.instant('gestion.seguimiento.objetivos.noMetas'),
        text: '',
        icon: 'info',
        confirmButtonColor: '#ff6b00',
        confirmButtonText: this.translate.instant('swal.acep'),
      });
    }
    this.obtenerPesoPers();
    this.viewTablero = true;
  }

  private ordenarPorPerspectiva(array: any) {
    var aux = [];
    for (const per of this.perspectives) {
      for (var i = 0; i < array.length; i++) {
        if (per.id === this.obtenerIdPer(array[i].objectiveId.id)) {
          aux.push(array[i]);
        }
      }
    }
    return aux;
  }

  private obtenerIdPer(idObj) {
    for (const obj of this.objectivos) {
      if (obj.id === idObj) {
        return obj.idPer;
      }
    }
  }

  private obtenerPesoPers() {
    const porc = this.porcentajeObjecAcum();
    this.porcentajeAvance = isNaN(porc) ? 0 : porc;

    for (const per of this.perspectives) {
      const avance = this.porcentajePersAcum(per.id);
      per.avance = isNaN(avance) ? 0 : avance;
    }
  }

  // Cambios en filtros
  public cambioAnio(periodoSel: any) {
    periodoSel = periodoSel.periodo;
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        mes.periodo === periodoSel ? mes.check = true : mes.check = false;
        mes.periodo === periodoSel ? this.Periodo = mes.periodo : '';
      }
    }

    this.indicadoresMostrar = [];
    for (const pro of this.indicadores) {
      if (this.Mostrar(pro)) {
        this.indicadoresMostrar.push(pro);
      }
    }
    if (this.indicadoresMostrar.length === 0) {
      Swal.fire({
        title: this.translate.instant('gestion.seguimiento.objetivos.noMetas'),
        text: '',
        icon: 'info',
        confirmButtonColor: '#ff6b00',
        confirmButtonText: this.translate.instant('swal.acep'),
      });
    }
    this.obtenerPesoPers();
  }
  public cambioPer(perSelec: any) {
    if(perSelec !== 'consolidado'){
      this.perspectives.forEach(res =>{ res.name === perSelec.name? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.perspectives.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.perspectives.length){
        this.todasPer = true
      }else{
        this.todasPer = false;
      }
    }else{
      if(this.todasPer){
        this.perspectives.forEach(res =>{ res.check = false});
      }else{
        this.perspectives.forEach(res =>{ res.check = true});
      }
      this.todasPer = !this.todasPer
      
    }
    if( perSelec !== undefined || this.todasPer){
      if(perSelec !== 'consolidado' || this.todasPer){
        this.indicadoresMostrar = [];
        for (const ind of this.indicadores) {
          if (this.Mostrar(ind)) {
            this.indicadoresMostrar.push(ind);
          }
        }
      }
      this.obtenerPesoPers();
    }
  }

  public selecAllPer() {
    this.perspectives.forEach(per => { this.todasPer ? per.check = false : per.check = true });
    this.todasPer = !this.todasPer;

    if(this.todasPer){
      this.indicadoresMostrar = [];
      for (const ind of this.indicadores) {
        if (this.Mostrar(ind)) {
          this.indicadoresMostrar.push(ind);
        }
      }
      this.obtenerPesoPers();
    }
  }
  public cambioLider(lidSelec: any) {
    if(lidSelec !== 'consolidado'){
      this.responsables.forEach(res =>{ res.nombre === lidSelec.nombre? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsables.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsables.length){
        this.selAll = true
      }else{
        this.selAll = false;
      }
    }else{
      if(this.selAll){
        this.responsables.forEach(res =>{ res.check = false});
      }else{
        this.responsables.forEach(res =>{ res.check = true});
      }
      this.selAll = !this.selAll
      
    }
    if( lidSelec !== undefined || this.selAll){
      if(lidSelec !== 'consolidado' || this.selAll){
        this.indicadoresMostrar = [];
        for (const ind of this.indicadores) {
          if (this.Mostrar(ind)) {
            this.indicadoresMostrar.push(ind);
          }
        }
      }
      this.obtenerPesoPers();
    }
  }
  public selectAll() {
    this.responsables.forEach(res => { this.selAll ? res.check = false : res.check = true });
    this.selAll = !this.selAll;

    if (this.selAll) {
      this.indicadoresMostrar = [];
      for (const ind of this.indicadores) {
        if (this.Mostrar(ind)) {
          this.indicadoresMostrar.push(ind);
        }
      }
    }
    this.obtenerPesoPers();
  }

  // Metodos de ordenamiento
  public ordenamientoId(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  public ordenamientoObjId(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.objectiveId.id) > Number(b.objectiveId.id)) {
        return 1;
      }
      if (Number(a.objectiveId.id) < Number(b.objectiveId.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  public ordenamientoMetas(array: any) {
    array.sort(function (a: any, b: any) {
      if ((a.period) > (b.period)) {
        return 1;
      }
      if ((a.period) < (b.period)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  public ordenamientoAd(array: any) {
    array.sort(function (a: any, b: any) {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  public ordenamientoSem(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.value_00) > Number(b.value_00)) {
        return 1;
      }
      if (Number(a.value_00) < Number(b.value_00)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  // metodos de escritura tabla
  public escribirObj(ind: any, i: any) {
    if (this.indicadoresMostrar.length === 1) {
      return this.obtObj(ind.objectiveId.id);
    } else {
      if (i != 0) {
        if (Number(ind.objectiveId.id) != Number(this.indicadoresMostrar[i - 1].objectiveId.id))
          return this.obtObj(ind.objectiveId.id);
      } else if (i === 0) {
        return this.obtObj(ind.objectiveId.id);
      }
    }
    return '';
  }
  public escribirPer(ind: any, i: any) {
    var perid1, perid2;
    for (const obj of this.objectivos) {
      if (obj.id === this.indicadoresMostrar[i].objectiveId.id) {
        perid1 = obj.idPer;
      }
    }
    if (i != 0) {
      for (const obj of this.objectivos) {
        if (obj.id === this.indicadoresMostrar[i - 1].objectiveId.id) {
          perid2 = obj.idPer;
        }
      }
      if (perid1 != perid2) {
        return this.obtPer(perid1);
      }
    } else {
      return this.obtPer(perid1);
    }

    return '';
  }
  public escribirMeta(periodo: any, ind: any, sinfor?: any) {
    var nombre = '';
    for (const met of ind.metas) {
      nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
      if (nombre === periodo && sinfor === undefined) {
        return '' + this.formatearnormal(met.value);
      } else if (nombre === periodo && sinfor !== undefined) {
        return '' + met.value;
      }
    }
    return ''
  }

  public rendimiento(periodo: any, ind: any) {
    var nombre = '';
    const metas = ind.metas.filter(meta =>
      Meses.getMesesN(moment(meta.period).month() + 1) + '-' + moment(meta.period).format('YY') === periodo
    );
    const met = { real: metas[0].real === null ? null : metas[0].real, value: metas[0].value === null ? null : metas[0].value };
    if (met.real < 0 && met.value >= 0) {
      switch (ind.tendencia) {
        case '-1':
          const sem = this.semaforo.filter(sem => sem.valfin >= 100);
          return sem[0].valfin + ' %';
        case '1':
        case '0':
          return '0 %';
      }
    } else if (met.value < 0.0 && met.real !== null) {
      switch (ind.tendencia) {
        case '-1':
          if (met.real >= 0) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return 0 + ' %';
          } else if (met.value >= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value < met.real) {
            rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
            if (rendimiento < 0) { rendimiento = 0; }
            return Number((rendimiento).toFixed(1)) + ' %';
          }
          return '0 %';
        case '1':
        case '0':
          if (met.real >= 0) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value <= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value > met.real) {
            rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
            return Number((rendimiento).toFixed(1)) + ' %';
          }
          return '0 %';
      }
    } else if (met.value !== 0 && met.real !== 0 && met.real !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
          break;
        case '1':
        case '0':
          rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
          break;
      }
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin;
        }
      }
      if (rendimiento >= valfin) {
        rendimiento = valfin;
      }
      return Number((rendimiento).toFixed(1)) + ' %'
    } else if (met.value !== 0 && met.real === 0) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          rendimiento = valfin;
          break;
        case '1':
        case '0':
          rendimiento = 0;
          break;
      }
      return Number((rendimiento).toFixed(1)) + ' %'
    } else if (met.value === 0 && met.real !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          if (met.real === null) {
            return 0 + ' %';
          } else if (met.real <= 0) {
            return 100 + ' %';
          } else if (met.real > 0) {
            return 0 + ' %';
          }
          break;
        case '1':
        case '0':
          if (met.real === null) {
            return 0 + ' %';
          } else if (met.real >= 0) {
            return 100 + ' %';
          } else if (met.real < 0) {
            return 0 + ' %';
          }
          break;
      }
    } else if (met.value === 0 && met.real === null) {
      switch (ind.tendencia) {
        case '-1':
          return 0 + ' %';
        case '1':
        case '0':
          return 0 + ' %';
      }
    } else if (met.value !== 0 && met.real === null) {
      return '0 %';
    }
    return '';
  }
  public escribirReal(periodo: any, ind: any, sinfor?: any) { //avance
    var nombre = '';
    for (const met of ind.metas) {
      nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
      if (nombre === periodo && sinfor === undefined) {
        if (met.real === null || met.real === 'null') {
          return 'null'
        }
        return '' + this.formatearnormal(met.real);
      } else if (nombre === periodo && sinfor !== undefined) {
        return '' + met.real;
      }
    }
    return ''
  }

  public pintarBorde(valor: any, meta: any, ind: any) {
    const met = Number(meta), val = Number(valor);
    var porcen = undefined, col = '';
    if (val === 0 && met !== 0 && this.dataService.company_name === 'Unión Popular') {//'Raiffeisen Latina' ){//
      return 'bordeNegro'
    }
    let dat = ind.split('%');
    porcen = Number(dat[0]);
    if (isNaN(val)) {
      porcen = undefined;
    }
    if (porcen !== undefined) {
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin
        }
      }
      if (porcen >= valfin) {
        porcen = valfin - 1;
      }
      for (const sem of this.semaforo) {
        var ab = sem.valIn;
        if (ab !== 0) {
          ab = ab - 0.1;
        }
        if (porcen >= ab && porcen <= sem.valfin) {
          col = sem.color;
          break;
        }
      }
      switch (col) {
        case 'rojo': return 'bordeRojo';
        case 'naranja': return 'bordeNaranja';
        case 'amarillo': return 'bordeAmarillo';
        case 'azul': return 'bordeAzul';
        case 'verde': return 'bordeVerde';
      }
    }
    return 'bordeGris';
  }

  //Porcentajes acumulados
  public porcentajeObjecAcum() {
    var persPon = 0, perTot = 0;

    var pesoFin = 0;
    for (const obj of this.objectivos) {
      var por = this.porcentajeObjAcum(obj.id), porcentajeObj = obj.peso;
      if (por != undefined) {
        pesoFin += obj.peso;
        persPon += por * porcentajeObj / 100;
      }
    }

    if (persPon !== 0) {
      persPon = persPon * 100 / pesoFin;
    }

    var valfin = 0;
    for (const sem of this.semaforo) {
      if (valfin < sem.valfin) {
        valfin = sem.valfin;
      }
    }
    if (persPon >= valfin) {
      persPon = valfin;
    }
    return Number((persPon).toFixed(0));
  }

  //eliminar archivos
  public async deleteArchivo() {
    const per = this.perSelected();
    const result = await messages.confirmationSave(
      this.translate.instant('gestion.seguimiento.objetivos.eliminarArchivo'),
      this.translate.instant(''),
      this.translate
    );

    if (result) {
      const spinner = document.getElementById('cargando_arch');
      if (spinner) spinner.style.display = 'block';
      for (const fil of this.adDelete.files) {
        if (Meses.obtnerPer(fil.created_at) === per) {
          try {
            await firstValueFrom(this.adicionalService.deleteFile(this.adDelete.id, fil.id));
            const ind = this.indicadores.find( i => Number(i.id) === Number(this.adDelete.indicatorId));
            const adicEd = ind.additions.find( a => Number(a.id) === Number(this.adDelete.id));
            adicEd.files = adicEd.files.filter( f => Number(f.id) !== Number(fil.id));
            messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
          } catch (err) {
            let er = obtenerError.errorObt(err['error']?.message);
            messages.errorMessageGraph(er);
          }
        }
      }
      if (spinner) spinner.style.display = 'none';
    }
  }

  //OBTENCION NOMBRES:
  private obtObj(objectiveid: any) {
    for (const obj of this.objectivos) {
      if (obj.id === objectiveid) {
        return obj.nombre;
      }
    }
  }
  private obtPer(perId: any) {
    for (const per of this.perspectives) {
      if (per.id === perId) {
        return per.name
      }
    }
  }
  public obtRes(i: any) {
    var areaId = this.indicadoresMostrar[i].areaId;
    for (const res of this.responsables) {
      if (res.id === areaId) {
        return res.nombre;
      }
    }
    return '';
  }
  private perSelected() {
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          return mes.periodo;
        }
      }
    }
    return '';
  }

  //Formatear datos
  public formatearnormal(num: any) {
    num = Number(Number(num).toFixed(2));
    num += '';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    if (splitRight === '.00' || splitRight === '.0')
      return splitLeft;
    return splitLeft + splitRight;
  }

  public porcentajePersAcum(nomPer: string) {
    var persel = this.perSelected(), i = 0, metasTot = 0;
    let fechaPer = this.fechaMeta(persel);
    var porcentaje = 0;
    let pesoPer = 0, peso = 0;

    for (const obj of this.objectivos) {
      if (Number(obj.idPer) === Number(nomPer)) {
        for (const ind of this.indicadores) {
          var per = this.escribirPerT(ind, i), pondInd = this.obtenerPondIndAcum(ind);
          let metas = ind.metas;
          for (var i = metas.length - 1; i >= 0; i--) {
            const peer = this.fechaMetas(metas[i].period);
            if (fechaPer === peer && Number(obj.id) === Number(ind.objectiveId.id)) {
              const val = this.escribirRealacum(Meses.obtnerPer(metas[i].period), ind);
              const met = this.escribirMetaacum(Meses.obtnerPer(metas[i].period), ind);
              var porcen = undefined;
              let dat = this.rendimientoacum(val, met, ind).split('%');
              porcen = Number(dat[0]);
              if (isNaN(val) || isNaN(Number(dat[0]))) {
                porcen = undefined;
              }
              if (porcen !== undefined) {
                var valfin = 0;
                for (const sem of this.semaforo) {
                  if (valfin < sem.valfin) {
                    valfin = sem.valfin;
                  }
                }
                if (porcen >= valfin) {
                  porcen = valfin;
                }

                porcen = porcen * pondInd / 100;
                porcentaje += porcen;
                metasTot++;
              }
              break;
            } else if (fechaPer > peer && metas[i].real !== null && Number(obj.id) === Number(ind.objectiveId.id) && moment(peer).year() === moment(fechaPer).year()) {
              const val = this.escribirRealacum(Meses.obtnerPer(metas[i].period), ind);
              const met = this.escribirMetaacum(Meses.obtnerPer(metas[i].period), ind);
              var porcen = undefined;
              let dat = this.rendimientoacum(val, met, ind).split('%');
              porcen = Number(dat[0]);
              if (isNaN(val) || isNaN(Number(dat[0]))) {
                porcen = undefined;
              }
              if (porcen !== undefined) {
                var valfin = 0;
                for (const sem of this.semaforo) {
                  if (valfin < sem.valfin) {
                    valfin = sem.valfin;
                  }
                }
                if (porcen >= valfin) {
                  porcen = valfin;
                }

                porcen = porcen * pondInd / 100;
                porcentaje += porcen;
                metasTot++;
              } else {
                porcen === 0;
              }
              break;
            }
          }
        }
        if (porcentaje !== 0) {
          peso += porcentaje * obj.peso / 100;
          pesoPer += obj.peso;
        }
        porcentaje = Number(porcentaje.toFixed(0));
        porcentaje = 0;
      }
    }

    if (peso !== 0) {
      porcentaje = peso * 100 / pesoPer;
    } else {
      porcentaje = 0;
    }

    var valfin = 0;
    for (const sem of this.semaforo) {
      if (valfin < sem.valfin) {
        valfin = sem.valfin
      }
    }
    if (porcentaje >= valfin) {
      porcentaje = valfin;
    }

    if (metasTot !== 0)
      return Number(porcentaje.toFixed(0));//*100/ponderacionPer
    else {
      return undefined
    }
    return 0
  }

  private obtenerPondIndAcum(ind: any) {
    var Nind = 0;
    for (const indi of this.indicadores) {
      if (Number(ind.objectiveId.id) === Number(indi.objectiveId.id) && this.porcentajeIndAcum(indi) !== undefined) {
        Nind += indi.ponderacion;
      }
    }
    return ind.ponderacion * 100 / Nind;
  }

  private porcentajeIndAcum(ind: any) {
    var persel = this.perSelected(), metasTot = 0;
    let fechaPer = this.fechaMeta(persel);
    var porcentaje = undefined;
    for (var i = ind.metas.length - 1; i >= 0; i--) {
      const peer = this.fechaMetas(ind.metas[i].period);
      if (fechaPer === peer) {
        const val = this.escribirRealacum(Meses.obtnerPer(ind.metas[i].period), ind);
        const met = this.escribirMetaacum(Meses.obtnerPer(ind.metas[i].period), ind);
        let dat = this.rendimientoacum(val, met, ind).split('%');
        porcentaje = Number(dat[0]);
        if (isNaN(val)) {
          porcentaje = undefined;
        }
        if (porcentaje !== undefined) {
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          if (porcentaje >= valfin) {
            porcentaje = valfin;
          }
        } else {
          porcentaje === 0;
        }
        break;
      } else if (fechaPer > peer && ind.metas[i].real !== null && moment(peer).year() === moment(fechaPer).year()) {
        const val = this.escribirRealacum(Meses.obtnerPer(ind.metas[i].period), ind);
        const met = this.escribirMetaacum(Meses.obtnerPer(ind.metas[i].period), ind);
        let dat = this.rendimientoacum(val, met, ind).split('%');
        porcentaje = Number(dat[0]);
        if (isNaN(val)) {
          porcentaje = undefined;
        }
        if (porcentaje !== undefined) {
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          if (porcentaje >= valfin) {
            porcentaje = valfin;
          }
        }
        break;
      }
    }
    if (porcentaje !== undefined)
      return Number(porcentaje.toFixed(0));//*100/ponderacionPer
    else {
      return undefined
    }
  }

  public Mostrar(ind: any) {
    // Observar que exista al menos una meta en los periodos
    var perSele = [];
    var metasInd = [];
    var existeMet = false;
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          perSele.push(mes.periodo);
        }
      }
    }
    for (const met of ind.metas) {
      metasInd.push(Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY'));
    }
    for (const per of metasInd) {
      for (const perS of perSele) {
        if (per === perS) {
          existeMet = true;
        }
      }
    }

    //Observar que la perspectiva este activa
    var existPer = false, perInd;
    for (const obj of this.objectivos) {
      if (obj.id === ind.objectiveId.id) {
        perInd = this.obtPer(obj.idPer);
      }
    }

    if (this.todasPer) {
      existPer = true;
    } else {
      for (const per of this.perspectives) {
        if (per.check && per.name === perInd) {
          existPer = true;
        }
      }
    }

    //que el area este activa
    var areaAct = false;

    if(this.selAll){
      areaAct = true;
    }else{
      for (const area of this.responsables) {
        if (area.id === ind.areaId && area.check) {
          areaAct = true;
          break;
        }
      }
    }

    if (existeMet && existPer && areaAct)
      return true;
    return false;
  }

  public editar(periodo: any, ind: any) {
    var perAct = Meses.obtnerPer(moment().toDate());
    var perAnt = Meses.obtnerPerAnt(moment().toDate());
    if (this.edicion) {
      this.dat(periodo, ind);
      return;
    }
    if (Meses.compararPer(perAnt, perAct, periodo)) {
      this.dat(periodo, ind)
    } else {
      Swal.fire({
        title: this.translate.instant('gestion.seguimiento.objetivos.noEditable'),
        text: this.translate.instant('gestion.seguimiento.objetivos.noEditableText'),
        confirmButtonColor: '#ff6b00',
        confirmButtonText: this.translate.instant('swal.acep')
      });
    }
  }

  private async dat(periodo: any, ind: any) {
    var inputValue: any, introdujo: any, guardo = false;
    var nombre = '';
    for (const met of ind.metas) {
      nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
      if (nombre === periodo) {
        inputValue = Number(met.real)
      }
    }

    introdujo = await Swal.fire({
      title: this.translate.instant('gestion.seguimiento.objetivos.ingreseDato'),
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        guardo = true;
        return '';
      }
    });

    if (guardo) {
      for (const indd of this.indicadores) {
        if (indd.id === ind.id) {
          for (const met of indd.metas) {
            nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
            if (nombre === periodo) {
              if (introdujo.value !== '') {
                met.real = Number(introdujo.value);
              } else {
                met.real = null;
              }
              try {
                await firstValueFrom(this.metaService.patchMetasReal(met));
                this.obtenerPesoPers();
                messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
              } catch (err) {
                let er = obtenerError.errorObt(err['error']?.message);
                messages.errorMessageGraph(er);
              }
            }
          }
        }
      }
    }
  }

  public escribirAdicional(adic: any) {
    if (adic != undefined) {
      switch (adic.type) {
        case 'texto':
          return this.obtComment(adic.comments);
        case 'moneda':
          return this.formatearnormal(adic.amount);
        case 'numero':
          return this.obtCommentNumero(adic.comments);
        case 'archivo':
          var per = this.perSelected();
          for (const file of adic.files) {
            if (per === Meses.obtnerPer(file.created_at)) {
              return file.name.split('-')[file.name.split('-').length - 1];
            }
          }
          return '';
      }
    }
  }

  private obtCommentNumero(com: any) {
    for (const comen of com) {
      var per = 0;
      for (const an of this.aniosDisponibles) {
        for (const mes of an.series) {
          if (mes.check) {
            per = an.anio;
          }
        }
      }
      var percom = moment(comen.created_at).year();
      if (per === percom) {
        return comen.comment;
      }
    }
    return '';
  }
  private obtComment(com: any) {
    for (const comen of com) {
      var per = this.perSelected();
      var percom = Meses.obtnerPer(moment(comen.createdAt).toDate());
      if (per === percom) {
        return comen.comment;
      }
    }
    return '';
  }

  public async edicionAd(adic: any, id: any, event?: any) {
    var inputValue: any, introdujo: any, guardo = false;

    switch (adic.type) {
      case 'texto':
        inputValue = this.obtComment(adic.comments);
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.objetivos.ingreseComentario'),
          text: "",
          input: 'text',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            guardo = true;
            return '';
          }
        });
        break;
      case 'moneda':
        inputValue = adic.amount;
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.objetivos.ingreseMonto'),
          text: "",
          input: 'number',
          inputValue: inputValue,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('gestion.seguimiento.objetivos.ingreseDatoValido');
            }
            guardo = true;
            return '';
          }
        });
        break;
      case 'archivo':
        inputValue = adic.file;
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.objetivos.seleccArchivo'),
          text: "",
          input: 'file',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('gestion.seguimiento.objetivos.ingreseDatoValido');
            }
            guardo = true;
            return '';
          }
        });
        break;
    }

    if (guardo) {
      switch (adic.type) {
        case 'texto':
          var existe = false;
          var per = this.perSelected();
          for (const comen of adic.comments) {
            var percom = Meses.obtnerPer(moment(comen.createdAt).toDate());
            if (per === percom && introdujo.value !== '') {
              comen.comment = introdujo.value;
              existe = true;
              try {
                await firstValueFrom(this.adicionalService.patchComment(comen, adic.id));
                const ind = this.indicadores.find( i => Number(i.id) === Number(adic.indicatorId));
                const adicEd = ind.additions.find( a => Number(a.id) === Number(adic.id));
                const comment = adicEd.comments.find( c => Number(c.id) === Number(comen.id));
                comment.comment = introdujo.value;
                messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
              } catch (err) {
                let er = obtenerError.errorObt(err['error']?.message);
                messages.errorMessageGraph(er);
              }
            }else if(per === percom && introdujo.value === ''){
              existe = true;
              try {
                await firstValueFrom(this.adicionalService.deleteComment(comen, adic.id));
                const ind = this.indicadores.find( i => Number(i.id) === Number(adic.indicatorId));
                const adicEd = ind.additions.find( a => Number(a.id) === Number(adic.id));
                adicEd.comments = adicEd.comments.filter( c => Number(c.id) !== Number(comen.id));
                messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
              } catch (err) {
                let er = obtenerError.errorObt(err['error']?.message);
                messages.errorMessageGraph(er);
              }
            }
          }
          if (!existe) {
            const[mesStr, anioStr] = per.split('-');
            const mesNum = Meses.getMesesS(mesStr);
            const anioNum = anioStr.length === 2 ? '20' + anioStr : anioStr;
            var date =  moment(`${anioNum}-${mesNum}-01`, 'YYYY-MM-DD').toDate();
            var aux = {
              comment: introdujo.value,
              createdAt: date.toISOString()
            }
            try {
              const res = await firstValueFrom(this.adicionalService.postComment(aux, adic.id));
              const ind = this.indicadores.find( i => Number(i.id) === Number(adic.indicatorId));
              const adicEd = ind.additions.find( a => Number(a.id) === Number(adic.id));
              adicEd.comments.push({
                ...aux,
                id: res.id
              });
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            } catch (err) {
              let er = obtenerError.errorObt(err['error']?.message);
              messages.errorMessageGraph(er);
            }
          }
          break;
        case 'moneda':
          adic.amount = introdujo.value;
          try {
            const response = await firstValueFrom(this.adicionalService.patchAdicionalesValues(adic));
            if (!response) {
              await Swal.fire({
                title: this.translate.instant('gestion.seguimiento.objetivos.noActualizado'),
                text: '',
                confirmButtonColor: '#ff6b00',
                cancelButtonColor: '#B9B9BC',
                confirmButtonText: this.translate.instant('swal.acep'),
                cancelButtonText: this.translate.instant('swal.cerr'),
              });
            } else {
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            }
          } catch (err) {
            let er = obtenerError.errorObt(err['error']?.message);
            messages.errorMessageGraph(er);
          }
          break;
        case 'archivo':
          messages.messageSaving(this.translate.instant('swal.agregandoInfo'), this.translate.instant('swal.espere'))
          this.progressInfo = [];
          introdujo.value ? this.imageName = introdujo.value.name : this.imageName = introdujo.value.length + " archivos";
          this.selectedFiles = introdujo.value;
          var per = this.perSelected();
          var existe = false;
          if (this.selectedFiles["size"] > obtenerTamMax.getPeso()) {
            Swal.fire({
              title: obtenerTamMax.getTexto(),
              text: '',
              showConfirmButton: false,
              icon: 'error',
              timer: this.dataService.time,
              didClose: () => {
                this.edicionAd(adic, id, event);
              }
            });
          } else {
            if (adic.files.length !== 0) {
              for (const fil of adic.files) {
                if (fil.periodo === per) {
                  existe = true;
                }
              }
            }
            if (!existe) {
              const fecha = moment(Meses.getMesesS(per.split('-')[0]) + '/1/' + per.split('-')[1], 'M/D/YY').toDate();
              try {
                const response = await firstValueFrom(this.adicionalService.postFile(this.selectedFiles, adic.id, fecha.toISOString()));
                const aux = {
                    id: response.id,
                    name: response.name,
                    description: null,
                    path: "",
                    created_at: moment(response.createdAt).toDate()
                }
                const ind = this.indicadores.find( i => Number(i.id) === Number(adic.indicatorId));
                const adicEd = ind.additions.find( a => Number(a.id) === Number(adic.id));
                adicEd.files.push(aux);
                messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
              } catch (err) {
                let er = obtenerError.errorObt(err['error']?.message);
                messages.errorMessageGraph(er)
              }
            }
          }
          break;
      }
    } else {
      Swal.fire({
        title: this.translate.instant('swal.cancelado'),
        text: '',
        icon: 'error',
        showConfirmButton: false,
        timer: this.dataService.time
      });
    }
  }

  public async abirPDF(ad: any, event?: any) {
    const per = this.perSelected();
    for (const fil of ad.files) {
      if (Meses.obtnerPer(moment(fil.created_at).toDate()) === per) {
        try {
          const response = await firstValueFrom(this.adicionalService.getFile(ad.id, fil.id));
          const extension = fil.name.split('.').pop().toLowerCase();
          let mediaType = '';
          let blob: Blob;

          switch (extension) {
            case 'pdf':
              mediaType = 'application/pdf';
              break;
            case 'png':
            case 'jpg':
              mediaType = 'image/' + extension;
              break;
            default:
              mediaType = 'application/' + extension;
              break;
          }
          blob = new Blob([response], { type: mediaType });

          const nav = (window.navigator as any);
          if (nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(blob, fil.name);
          } else {
            const a = document.createElement('a');
            const url = URL.createObjectURL(blob);
            a.href = url;
            const nombreDescarga = fil.name.includes('-') ? fil.name.split('-').slice(1).join('-') : fil.name;
            a.download = nombreDescarga;
            document.body.appendChild(a);

            if (extension === 'pdf') {
              window.open(a.href, "_blank");
            } else {
              a.click();
            }

            setTimeout(function () {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }, 0);
          }
        } catch (err) {
          let er = obtenerError.errorObt(err['error']?.message);
          await Swal.fire({
            title: er,
            text: '',
            icon: 'error',
            showConfirmButton: false,
            timer: this.dataService.time,
          });
        }
        break;
      }
    }
  }

  public porcentajeObjAcum(objId: string) {
    var persel = this.perSelected(), i = 0, metasTot = 0;
    let fechaPer = this.fechaMeta(persel);
    var porcentaje = 0;


    for (const ind of this.indicadores) {
      var per = this.escribirPerT(ind, i), pondInd = this.obtenerPondIndAcum(ind);
      let metas = ind.metas;
      for (var i = metas.length - 1; i >= 0; i--) {
        const peer = this.fechaMetas(metas[i].period);
        if (fechaPer === peer && Number(objId) === Number(ind.objectiveId.id)) {
          const val = this.escribirRealacum(Meses.obtnerPer(ind.metas[i].period), ind);
          const met = this.escribirMetaacum(Meses.obtnerPer(ind.metas[i].period), ind);
          var porcen = undefined;
          let dat = this.rendimientoacum(val, met, ind).split('%');
          porcen = Number(dat[0]);
          if (isNaN(val) || isNaN(Number(dat[0]))) {
            porcen = undefined;
          }
          if (porcen !== undefined) {
            var valfin = 0;
            for (const sem of this.semaforo) {
              if (valfin < sem.valfin) {
                valfin = sem.valfin;
              }
            }
            if (porcen >= valfin) {
              porcen = valfin;
            }

            porcen = porcen * pondInd / 100;
            porcentaje += porcen;
            metasTot++;
          }
          break;
        } else if (fechaPer > peer && metas[i].real !== null && Number(objId) === Number(ind.objectiveId.id) && moment(peer).year() === moment(fechaPer).year()) {
          const val = this.escribirRealacum(Meses.obtnerPer(ind.metas[i].period), ind);
          const met = this.escribirMetaacum(Meses.obtnerPer(ind.metas[i].period), ind);
          var porcen = undefined;
          let dat = this.rendimientoacum(val, met, ind).split('%');
          porcen = Number(dat[0]);
          if (isNaN(val) || isNaN(Number(dat[0]))) {
            porcen = undefined;
          }
          if (porcen !== undefined) {
            var valfin = 0;
            for (const sem of this.semaforo) {
              if (valfin < sem.valfin) {
                valfin = sem.valfin;
              }
            }
            if (porcen >= valfin) {
              porcen = valfin;
            }

            porcen = porcen * pondInd / 100;
            porcentaje += porcen;
            metasTot++;
          } else {
            porcen === 0;
          }
          break;
        }
      }
    }

    var valfin = 0;
    for (const sem of this.semaforo) {
      if (valfin < sem.valfin) {
        valfin = sem.valfin
      }
    }
    if (porcentaje >= valfin) {
      porcentaje = valfin;
    }
    if (metasTot !== 0)
      return Number(porcentaje.toFixed(0));//*100/ponderacionPer
    else {
      return undefined
    }
    return 0
  }

  public escribirMetaacum(periodo: any, ind: any) {
    var nombre = '';
    for (const met of ind.metas) {
      nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
      if (nombre === periodo) {
        return met.value;
      }
    }
    return ''
  }
  public escribirRealacum(periodo: any, ind: any) { //avance
    var nombre = '';
    for (const met of ind.metas) {
      nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
      if (nombre === periodo) {
        return met.real;
      }
    }
    return ''
  }

  public rendimientoacum(real: any, value: any, ind) {
    const met = { real: real === null ? null : real, value: value === null ? null : value };
    if (met.real < 0 && met.value >= 0) {
      switch (ind.tendencia) {
        case '-1':
          const sem = this.semaforo.filter(sem => sem.valfin >= 100);
          return sem[0].valfin + ' %';
        case '1':
        case '0':
          return '0 %';
      }
    } else if (met.value < 0.0 && met.real !== null) {
      switch (ind.tendencia) {
        case '-1':
          if (met.real > 0) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return 0 + ' %';
          } else if (met.value <= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value > met.real) {
            rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
            if (rendimiento < 0) { rendimiento = 0; }
            return Number((rendimiento).toFixed(1)) + ' %';
          }
          return '0 %';
        case '1':
        case '0':
          if (met.real > 0) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value >= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value < met.real) {
            rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
            return Number((rendimiento).toFixed(1)) + ' %';
          }
          return '0 %';
      }
    } else if (met.value !== 0 && met.real !== 0 && met.real !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
          break;
        case '1':
        case '0':
          rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
          break;
      }
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin;
        }
      }
      if (rendimiento >= valfin) {
        rendimiento = valfin;
      }
      return Number((rendimiento).toFixed(1)) + ' %'
    } else if (met.value !== 0 && met.real === 0) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          rendimiento = valfin;
          break;
        case '1':
        case '0':
          rendimiento = 0;
          break;
      }
      return Number((rendimiento).toFixed(1)) + ' %'
    } else if (met.value === 0 && met.real !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          if (met.real === null) {
            return 0 + ' %';
          } else if (met.real <= 0) {
            return 100 + ' %';
          } else if (met.real > 0) {
            return 0 + ' %';
          }
          break;
        case '1':
        case '0':
          if (met.real === null) {
            return 0 + ' %';
          } else if (met.real >= 0) {
            return 100 + ' %';
          } else if (met.real < 0) {
            return 0 + ' %';
          }
          break;
      }
    } else if (met.value === 0 && met.real === null) {
      switch (ind.tendencia) {
        case '-1':
          return 0 + ' %';
        case '1':
        case '0':
          return 0 + ' %';
      }
    } else if (met.value !== 0 && met.real === null) {
      return '0 %';
    }
    return '';
  }

  private fechaMeta(periodo) {
    let fecha = moment(Meses.getMesesNum(periodo.split('-')[0]) + '-01-' + periodo.split('-')[1], 'MM-DD-YY');
    return fecha.format("YYYY-DD-MM");
  }
  private fechaMetas(periodo) {
    return moment(periodo).format("YYYY-DD-MM");
  }

  public escribirPerT(ind: any, i: any) {
    var perid1;
    for (const obj of this.objectivos) {
      if (obj.id === ind.objectiveId.id) {
        perid1 = obj.idPer;
      }
    }
    return this.obtPer(perid1);

  }
  public porcentajeObjec() {
    var persPon = 0;
    for (const per of this.perspectives) {
      var por = this.porcentajePers(per.name), porPer = this.obtenerPorcentajePer(this.obtenerPonder(per.name));
      if (por !== undefined) {
        persPon += Number((por * porPer / 100).toFixed(2));
      }
    }
    return Number(persPon.toFixed(0));
  }

  private obtenerPorcentajePer(per: any) {
    var ponderacionPer = 0;
    var i = 0, objList: any = [];

    for (const ind of this.indicadoresMostrar) {
      if (!objList.includes(ind.objectiveId.id)) {
        objList.push(ind.objectiveId.id);
      }
    }
    for (const obj of this.objectivos) {
      if (objList.includes(obj.id)) {
        ponderacionPer += obj.peso;
      }
    }
    return Number((per * 100 / ponderacionPer).toFixed(2));
  }

  private obtenerPonder(nomPer: any) {
    var ponderacionPer = 0, persel = this.perSelected();
    var i = 0, objList: any = [];

    for (const ind of this.indicadoresMostrar) {
      var per = this.escribirPerT(ind, i);
      for (const met of ind.metas) {
        if (persel === Meses.obtnerPer(moment(met.period).toDate()) && nomPer === per) {
          if (!objList.includes(ind.objectiveId.id)) {
            objList.push(ind.objectiveId.id);
          }
        }
      }
      i++;
    }

    for (const per of this.perspectives) {
      for (const obj of this.objectivos) {
        if (per.id === obj.idPer && per.name === nomPer && objList.includes(obj.id)) {
          ponderacionPer += obj.peso;
        }
      }
    }
    return ponderacionPer;
  }
  private obtenerPondInd(ind: any) {
    var Nind = 0;
    for (const indi of this.indicadoresMostrar) {
      if (ind.objectiveId.id === indi.objectiveId.id) {
        Nind += indi.ponderacion;
      }
    }
    return Number((ind.ponderacion * 100 / Nind).toFixed(2));
  }

  public porcentajePers(nomPer: string) {
    var persel = this.perSelected(), i = 0, metasTot = 0;
    var porcentaje = 0, ponderacionPer = this.obtenerPonder(nomPer);

    for (const ind of this.indicadoresMostrar) {
      var per = this.escribirPerT(ind, i), pondInd = this.obtenerPondInd(ind);
      for (const met of ind.metas) {
        if (persel === Meses.obtnerPer(moment(met.period).toDate()) && nomPer === per) {
          const val = Number(this.escribirReal(persel, ind)), met = Number(this.escribirMeta(persel, ind));

          var porcen = Number(this.rendimiento(persel, ind).split('%')[0]);
          if (porcen === 0) {
            porcen = undefined;
            var por = 0;
            porcentaje += 0;
            metasTot++;
          }

          if (porcen !== undefined) {
            var valfin = 0;
            for (const sem of this.semaforo) {
              if (valfin < sem.valfin) {
                valfin = sem.valfin
              }
            }
            if (porcen >= valfin) {
              porcen = valfin;
            }

            porcen = porcen * pondInd / 100;
            porcen = porcen * ind.objectiveId.weighing / 100;
            porcen = porcen * 100 / ponderacionPer;
            porcentaje += porcen;
            metasTot++;
          }
          break;
        }
      }

      i++;
    }
    if (metasTot != 0)
      return Number((porcentaje).toFixed(0));//*100/ponderacionPer
    else {
      return undefined
    }
  }
  public escribirObjTar(ind: any, i: any) {
    return this.obtObj(ind.objectiveId.id);
  }
  private porcentajeObj(nomPer: string) {
    var persel = this.perSelected(), i = 0, metasTot = 0;
    var porcentaje = 0;

    for (const ind of this.indicadoresMostrar) {
      var per = this.escribirObjTar(ind, i), pondInd = this.obtenerPondInd(ind);
      for (const met of ind.metas) {
        if (persel === Meses.obtnerPer(moment(met.period).toDate()) && nomPer === per) {
          var porcen = Number(this.rendimiento(persel, ind).split('%')[0]) * pondInd / 100;
          porcentaje += porcen;
          metasTot++;
          break;
        }
      }
      i++;
    }
    if (metasTot != 0)
      return Number((porcentaje).toFixed(2));
    else {
      return undefined
    }
  }

  public pintarBordeT(valor: any) {
    if (valor != undefined) {
      var color = '';
      if (valor !== 0) {
        var valfin = 0;
        for (const sem of this.semaforo) {
          if (valfin < sem.valfin) {
            valfin = sem.valfin
          }
        }
        if (valor >= valfin) {
          valor = valfin - 1;
        }
        for (const sem of this.semaforo) {
          var ab = sem.valIn;
          if (ab !== 0) {
            ab = ab - 0.1;
          }
          if (valor >= ab && valor < sem.valfin) {
            color = sem.color;
            break;
          }
        }
      }
      switch (color) {
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default: return 'bordeGrey';
      }
    } else {
      return 'bordeGrey';
    }
  }

  public texto(valor: any) {
    var color = '';
    if (valor != 0) {
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin
        }
      }
      if (valor >= valfin) {
        valor = valfin - 1;
      }
      for (const sem of this.semaforo) {
        var ab = sem.valIn;
        if (ab !== 0) {
          ab = ab - 0.1;
        }
        if (valor >= ab && valor < sem.valfin) {
          color = sem.color;
          break;
        }
      }
    }
    switch (color) {
      case 'verde': return 'cifraSecVerd';
      case 'azul': return 'cifraSecAzul';
      case 'amarillo': return 'cifraSecAmar';
      case 'naranja': return 'cifraSecNarj';
      case 'rojo': return 'cifraSecRojo';
      default: return 'cifraSecGris';
    }
  }

  public exportar_excel() {
    const title = 'Seguimiento: Objetivos de ' + this.Periodo;
    let tit = [];
    let esp = [];
    for (const ad of this.indicadoresMostrar[0].additions) {
      if (ad.type === 'texto') {
        tit.push('' + ad.name);
        esp.push('');
      }
    }
    let header = ["Indicador", "Ponderación", "Responsable", "Meta", "Avance", "Rendimiento"];
    header = header.concat(tit);
    var data = [], aux = [];
    for (var i = 0; i < this.indicadoresMostrar.length; i++) {
      if (this.escribirPer(this.indicadoresMostrar[i], i) != '') {
        aux.push('', this.escribirPer(this.indicadoresMostrar[i], i));
        aux.push('', '', 'Ponderación', this.porcentajePers(this.escribirPer(this.indicadoresMostrar[i], i)) / 100);
        aux = aux.concat(esp);
        data.push(aux);
        aux = [];
      }
      if (this.escribirObj(this.indicadoresMostrar[i], i) != '') {
        aux.push(this.escribirObj(this.indicadoresMostrar[i], i));
        aux.push('', '', '', 'Ponderación', this.porcentajeObj('' + this.escribirObj(this.indicadoresMostrar[i], i)) / 100);
        aux = aux.concat(esp);
        data.push(aux);
        aux = [];
      }
      aux.push((this.verCodigo ? 'Código | ' : '') + '' + this.indicadoresMostrar[i].nombre);
      aux.push(this.indicadoresMostrar[i].ponderacion);
      aux.push(this.obtRes(i));
      for (const an of this.aniosDisponibles) {
        for (const mes of an.series) {
          if (mes.check) {
            var real = (Number(this.escribirReal(mes.periodo, this.indicadoresMostrar[i], 'ss')));
            aux.push(Number(this.escribirMeta(mes.periodo, this.indicadoresMostrar[i], 'ss')));
            aux.push(isNaN(real) ? 0 : real);
            aux.push(Number((this.rendimiento(mes.periodo, this.indicadoresMostrar[i])).split(' ')[0]) / 100);
          }
        }
      }
      for (const ad of this.indicadoresMostrar[i].additions) {
        if (ad.type === 'texto') {
          aux.push(this.escribirAdicional(ad));
        }
      }
      data.push(aux);
      aux = [];
    }
    const avance = this.porcentajeObjecAcum() / 100;
    const NomArch = 'Inidicadores_objetivos';
    this.excelService.generateExcelObjetivos2(title, header, data, NomArch, this.semaforo, avance);
  }
  // Menu click izquierdo
  public onContextMenu(event: MouseEvent, item) {
    event.preventDefault();
    // we record the mouse position in our object 
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';

    this.adDelete = item;

    this.matMenuTrigger.openMenu();
  }

  public borrarFiltros(){
    this.todasPer = true;
    this.selAll = true;

    var per = this.aniosDisponibles[this.aniosDisponibles.length-1].series[this.aniosDisponibles[this.aniosDisponibles.length-1].series.length-1]; 
    const Periodo = per.periodo;
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        if(mes.periodo !== Periodo){
          mes.check = false;
        }else{
          mes.check = true;
        }
      }
    }

    this.indicadoresMostrar = [];
    for (const ind of this.indicadores) {
      if (this.Mostrar(ind)) {
        this.indicadoresMostrar.push(ind);
      }
    }
    this.obtenerPesoPers();
  }
}
